// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeObjectGetBatchBody = {
  mediaIds: string[];
};

export type typeObjectGetBatchOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      mediaId: string;
      status: "published" | "pendingReview" | "heldOnBudget" | "rejected";
      variants?: {
        original: { url: string };
        large: { url: string };
        thumbnail: { url: string };
      } | null;
      fileName?: string | null;
      byteSize?: number | null;
    }[];
    total: number;
  };
};

export type typeObjectGetBatchOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeObjectGetBatchOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeObjectGetBatchOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaObjectGetBatchBody = {
  type: "object",
  properties: {
    mediaIds: {
      type: "array",
      maxItems: 200,
      description: "At most 200 media ids.",
      items: { type: "string", maxLength: 3000, minLength: 1 },
    },
  },
  required: ["mediaIds"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createObjectGetBatch(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaObjectGetBatchBody);
  }

  return async function postObjectGetBatch(
    payload: typeObjectGetBatchBody,
  ): Promise<typeObjectGetBatchOutput200 | typeObjectGetBatchOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postObjectGetBatch" failed before calling the network. #125e4dccc5a4`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#125e4dccc5a4" },
        },
        data: null,
      } as typeObjectGetBatchOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/object/get-batch`,
      httpMethod: "POST",
      options,
    })) as typeObjectGetBatchOutput200 | typeObjectGetBatchOutput400;
  };
}
